/**
 * Temperature conversion utilities.
 * All conversions use Celsius as the base unit internally.
 */

import { Units } from '../../units';

/**
 * Convert a temperature value from a source unit to Celsius (base unit).
 */
export function tempToCelsius(value: number, fromUnit: string): number {
  switch (fromUnit.toLowerCase().trim()) {
    case 'f':
    case '°f':
    case 'fahrenheit':
    case 'fahrentheit':
      return (value - 32) * (5 / 9);
    case 'k':
    case 'kelvin':
      return value - 273.15;
    case 'c':
    case '°c':
    case 'celsius':
    default:
      return value;
  }
}

/**
 * Convert a temperature value from Celsius to the target unit system.
 */
export function tempFromCelsius(
  valueCelsius: number,
  targetSystem: Units,
): { value: number; unit: string } {
  switch (targetSystem) {
    case Units.IMPERIAL:
      return { value: valueCelsius * (9 / 5) + 32, unit: '°F' };
    case Units.METRIC:
    case Units.MARITIME:
    default:
      return { value: valueCelsius, unit: '°C' };
  }
}

/**
 * Convert a temperature from a source unit to the user's preferred system.
 */
export function convertTemperature(
  value: number,
  fromUnit: string,
  targetSystem: Units,
): { value: number; unit: string } {
  const celsius = tempToCelsius(value, fromUnit);
  return tempFromCelsius(celsius, targetSystem);
}
